<!-- Komponen PDF Generator (Hidden from UI) -->
<template>
  <vue-html2pdf
    ref="html2Pdf"
    :show-layout="false"
    :float-layout="true"
    :enable-download="true"
    :preview-modal="false"
    :paginate-elements-by-height="2000"
    filename="Komerce-Balance-Report"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    pdf-content-width="100%"
    :html-to-pdf-options="{
      margin: [8, 8, 8, 8],
      filename: 'Komerce-Balance.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: 'avoid-all' }
    }"
    @hasStartedGeneration="$emit('loading', true)"
    @hasGenerated="$emit('loading', false)"
  >
    <section
      slot="pdf-content"
      class="p-2 pdf-page"
      :class="{ 'compact-mode': isCompact }"
    >
      <h2 class="text-left mb-2 text-black">
        Komerce Balance
      </h2>
      <div class="mb-2 d-flex">
        <div class="k-calendar text-3xl mr-1" />
        <div class="align-self-center">
          {{ formattedToday }}
        </div>
      </div>
      <div class="d-flex gap-5">
        <Card
          title="Cash in Bank"
          :balance="balanceInBank"
          :list="listCashInBank"
          :is-pdf-mode="true"
          class="w-50"
        />
        <Card
          title="Cash in Payment Gateway"
          :balance="balanceInPaymentGateway"
          :list="listCashInPaymentGateway"
          :is-pdf-mode="true"
          class="w-50"
        />
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Card from './Card.vue'

export default {
  components: {
    VueHtml2pdf,
    Card,
  },
  props: {
    formattedToday: {
      type: String,
      required: true,
    },
    balanceInBank: {
      type: Number,
      default: 0,
    },
    listCashInBank: {
      type: Array,
      default: () => [],
    },
    balanceInPaymentGateway: {
      type: Number,
      default: 0,
    },
    listCashInPaymentGateway: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isCompact() {
      // Logika jika total list bank + payment gateway lebih dari 3
      return (this.listCashInBank.length + this.listCashInPaymentGateway.length) > 3
    },
  },
  methods: {
    generate() {
      this.$refs.html2Pdf.generatePdf()
    },
  },
}
</script>

<style scoped>
.pdf-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  /* Menghilangkan potensi overflow yang memicu halaman baru */
  overflow: hidden;
}

/* Compact mode: Menggunakan property fisik daripada scale agar bounding box ikut mengecil */
.compact-mode ::v-deep .card {
  margin-bottom: 6px !important;
}

.compact-mode ::v-deep .card-body {
  padding: 0.5rem !important;
}

.compact-mode ::v-deep h5 {
  font-size: 1rem !important;
}

.compact-mode ::v-deep .text-2xl {
  font-size: 1.1rem !important;
}

.compact-mode ::v-deep .h-14 {
  height: 2.5rem !important;
  width: 2.5rem !important;
}
</style>
